import * as React from 'react';

import { BaseComponentProps, BaseComponentState, BaseComponent } from '../base/BaseComponent';
import { Link } from 'react-router-dom';
import { momentWrapper } from '../utils/index';

export interface Section3Props extends BaseComponentProps {
    lang: string;
}
export interface Section3State extends BaseComponentState { }

export class Section3 extends BaseComponent<Section3Props, Section3State> {

    render() {
        if (this.state.haveReactError) {
            return this.renderErrorPanel();
        }
        return (

            <div className="footer-copyright" style={{ pading: '15px 0' } as any}>
                <div className="container">
                    <div className="row">
                        <div className="col-md-8">
                            <div className="row">
                                <nav id="sub-menu" style={{ paddingBottom: 5, borderBottom: '1px solid', marginBottom: 5 }} className="nav navbar-nav navbar-left">
                                    <ul>
                                        <li>
                                            <Link to="/faqs"> FAQ's </Link>
                                        </li>
                                        <li>
                                            <Link to="/sitemap"> Sitemap </Link>
                                        </li>
                                        <li>
                                            <Link to="contact-us"> Contact </Link>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                            <p className="row">
                                &copy; Copyright <span className="current-year">{momentWrapper().format('YYYY')}</span> by Bali Hotels and More (CV AUSTINDO INFORMATIKA). All Rights Reserved.
                                </p>
                        </div>
                        <div className="col-md-4" style={{ textAlign: 'right' }}>
                            <i style={{ fontSize: 35 }} className='fa fa-credit-card' />    <i style={{ fontSize: 35 }} className='fa fa-cc-stripe' />   <i style={{ fontSize: 35 }} className='fa fa-cc-visa' />   <i style={{ fontSize: 35 }} className='fa fa-cc-mastercard' />   <i style={{ fontSize: 35 }} className='fa fa-cc-discover' />   <i style={{ fontSize: 35 }} className='fa fa-cc-amex' />

                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/footer/Section3.tsx